import r from "./map.js";
import o from "./property.js";
function p(p, t) {
  return r(p, o(t));
}
export { p as default };